
/**
 * When I wrote this code,Only God and I understood what I was doing.
 * Now,God only knows  !!!
 *
 * 聊天底部工具栏 如表情 图片 发送等
 *
 */
import {Component, Prop, Ref, Vue} from "vue-property-decorator";
import Emoji from "@/components/messageInteraction/emoji.vue";
import SebsutiveWord from "./sensitiveWord.js"
import {SizeEnum} from "@/ts/Enum";
import OSSClient from "@/oss/OssClient";
import { UiConfigModule } from '../../store/modules/uiConfig'

@Component({
    components: {Emoji}
})
export default class ChatTool extends Vue {
    @Prop() type: SizeEnum;
    @Prop() lessonId: string;
    @Prop() year: string;
    @Prop() gardenId: string;

    menuList = [
        {
            id: 1,
            name: '表情',
            class: 'menu-face',

        }
        // {
        //     id: 2,
        //     name: '图片',
        //     class: 'menu-screencut',
        // },
        // {
        //     id: 3,
        //     name: '文件',
        //     class: 'menu-pic',
        // }
    ];

    textarea = '';
    emojiVisable = {f: false};

    @Ref() readonly fileRef;
    @Ref() readonly chat;

    mounted(): void {
        if (this.isMobile) {
            this.judgeKeyboard()
        }
    }

  beforeDestroy() {
    if (!this.isMobile) {
        return
    }
    if (navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
      this.chat.$el.removeEventListener('focusin', this.handlePop)
      this.chat.$el.removeEventListener('focusout', this.handlePop)
    } else {
      window.onresize = null
    }
  }

  handlePop(){
    UiConfigModule.setPopKeyBoard(!UiConfigModule.popKeyBoard)
  }

  judgeKeyboard() {
    if(navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)){
      this.chat.$el.addEventListener('focusin', this.handlePop)
      this.chat.$el.addEventListener('focusout', this.handlePop)
    } else {
      const realHeight = document.documentElement.clientHeight ||document.body.clientHeight;
      window.onresize = () => {
        const showHeight = document.documentElement.clientHeight || document.body.clientHeight;
        if (showHeight<realHeight) {
          UiConfigModule.setPopKeyBoard(true)
        } else {
          UiConfigModule.setPopKeyBoard(false)
        }
      }
    }
  }

    menuClick(id) {
        switch (id) {
            case 1:
                this.emojiShow()
                break;
            case 2:
                break;
            case 3:
                this.uploadShow()
                break;
        }

    }

    emojiShow() {
        this.emojiVisable.f = !this.emojiVisable.f
    }

    uploadShow() {
        this.fileRef.dispatchEvent(new MouseEvent('click'))
    }

    /**
     * 聊天图片上传值OSS
     * <P>
     *  图片上传成功后，会将图片地址赋值给消息文本框的内容对象，然后发送出去
     * </P>
     */
    uploadFiles(e) {
        let executFile = e.target.files[0];
        var index = executFile.name.lastIndexOf('.')
        var ext = executFile.name.substr(index + 1)
        // png、jpg、jpeg、svg、gif
        const reg = /\.(png|jpg|jpeg|svg|gif)(\?.*)?$/
        if (!reg.test(executFile.name)) {
            this.$message.error(`上传文件格式不正确！`)
            return;
        }
        let newFile = new File([executFile], new Date().getTime() + '.' + ext)
        //上传文件
        let ossFilePath = this.filePre$.bucketImageFile;
        let ossBaseSrc = this.filePre$.ossBaseSrc;

        if (this.year) {
            ossFilePath += this.year;
        } else {
            ossFilePath += new Date().getFullYear()
        }
        ossFilePath += '年/gardenId-';
        if (this.gardenId) {
            ossFilePath += this.gardenId;
        } else {
            const gardenId = window.sessionStorage.getItem("gardenId")
            ossFilePath += gardenId
        }
        ossFilePath += '/';
        if (this.lessonId) {
            ossFilePath += this.lessonId;
        } else {
            ossFilePath += new Date().getTime();
        }
        ossFilePath += '/' + new Date().getTime() + newFile.name

        let client = OSSClient.createClient();
        let _this = this;
        OSSClient.multipartUpload(client, ossFilePath, newFile).then(res => {
            // const {requestUrls} = res["res"];
            // _this.textarea = `<img src="${requestUrls[0]}">`;
            // _this.textarea = requestUrls[0];
            _this.textarea = ossBaseSrc + ossFilePath;
            _this.sendMessage();
        })
    }

    chooseEmojiDefault(em) {
        this.textarea += em;
        this.emojiShow();
    }

    chooseEmoji(url) {
        // this.send(url, 'emoji');
        this.emojiShow();
    }


    // 换行
    lineFeed() {
        console.log("换行" + this.textarea)
        // this.textarea = this.textarea + '<br/>'

    }

    /**
     * 发送聊天消息
     */
    sendMessage() {

        this.textarea = this.textarea.trimStart().trimEnd().replace("\n", "<br/>");
        if (this.textarea != '') {
            //屏蔽字过滤
            for (let sebsutiveWordKey of SebsutiveWord.sebsutiveWord()) {
                //全局替换
                var reg = new RegExp(sebsutiveWordKey, "g");
                //判断内容中是否包括敏感词
                if (this.textarea.indexOf(sebsutiveWordKey) != -1) {
                    let zero = "";
                    for (let i = 0; i < sebsutiveWordKey.length; i++) {
                        zero = zero + "*";
                    }
                    this.textarea = this.textarea.replace(reg, zero);
                }

            }
            this.$emit('sendMessage', this.textarea);
            this.textarea = '';
        }
    }
}
